module.exports = __webpack_public_path__ + "img/codelos-icons.a8d58f32.svg";